<template>
  <v-container fluid>
    <validation-observer ref="observer" slim v-slot="{ invalid }">
      <v-row>
        <v-col class="pb-2">
          <base-material-card
            color="primary"
            icon="mdi-chart-bubble"
            inline
            class="px-5 py-4 ml-0"
            :title="title"
          >
            <v-row>
              <v-col 
              cols="12"
              class="py-0"
              >
                <v-alert 
                  dense
                  outlined 
                  type="warning"
                  class="mt-5 py-0 px-1"  
                >
                  Atenção: os índices importados serão replicados em todos os sistemas.
                </v-alert>
              </v-col>
              <v-col 
              cols="12"
              class="py-0"
              >
                <v-alert 
                  dense
                  outlined 
                  color="blue"
                  type="info"
                  class="pa-2"  
                >
                  O arquivo deve conter o seguinte cabeçalho: <b>COGE</b>,<b>Variação Mês</b>,<b>Índice Mês</b> com delimitador <b>;</b>

                </v-alert>
              </v-col>
              <v-col 
                cols="12" 
                class="pl-2">
                <validation-provider v-slot="{ errors }" rules="required"  id="indice-campo-select-arquivo">
                  <v-file-input
                    @change="uploadFile()"
                    label="Arquivo CSV"
                    placeholder="Selecione um arquivo CSV"
                    outlined
                    accept=".csv, .zip"
                    v-model="arquivo.fileObj"
                    loader-height="4"
                    truncate-length="30"
                    :error-messages="errors"
                    :success="arquivo.id && arquivo.fileObj ? true : false"
                  >
                  </v-file-input>
              </validation-provider>

              <validation-provider rules="required">
                <input type="hidden" name="validate-upload-indice-coge" :value="arquivo.id" />
              </validation-provider>
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col >
          <v-btn
            id="indice-campo-send"
            color="green" 
            style="float: right" 
            @click="openDialogPreview(arquivo.id)"
            :disabled="invalid"
            >
              Enviar
            </v-btn>
        </v-col>
      </v-row>
      <dialog-preview
        v-if="arquivo.id"
        :showDialog="dialogPreview"
        @changeValue="dialogPreview = $event"
        :indicesPreview="indicesPreview"
        :arquivoId="arquivo.id"
        @rechargeTable="openDialogPreview(arquivo.id)"
      >
      </dialog-preview>
    </validation-observer>
  </v-container>
</template>
<script>
import DateFormatterMixins from "@/mixins/dateFormatterMixins.js";
import IndicesCOGE from "@/services/IndicesCOGEService";
import ArquivosService from "@/services/ArquivosService.js";
import tourMixins from '@/mixins/tourMixins';

export default {

  components: {
    DialogPreview: () => import("@/components/indicesCOGE/DialogPreview.vue"),
  },

  mixins: [DateFormatterMixins, tourMixins],

  data: () => ({
    mesImportacao: "",
    dialogPreview: false,
    indicesPreview: [],
    arquivo: {
      fileObj: undefined,
      id: "",
      uploading: false,
    },
    arrTour: [
      {
        element: '#indice-campo-select-arquivo',
        intro: 'Aqui você deve selecionar um arquivo do tipo .ZIP ou CSV.',
        scrollTo: "tooltip",
        position: 'bottom'
      },
      {
        element: '#indice-campo-send',
        intro: 'Após a seleção do arquivo clique aqui para carregar a pré visualização do arquivo.',
        scrollTo: "tooltip",
        position: 'bottom'
      },
    ]
  }),

  mounted() {
    this.getMesImportacao();
  },

  computed: {
    title() {
      return (
        this.$route.name + " Para o Mês :: " + this.mesImportacao
      );
    },
  },

  methods: {
    uploadFile() {

      if(!this.arquivo.fileObj) return;

      this.arquivo.id = "";
      this.arquivo.uploading = true;
      
      let data = new FormData();
      data.append("file", this.arquivo.fileObj);
      ArquivosService.uploadFile(data)
        .then((response) => {
          this.arquivo.id = response.data.arquivoId;
        })
        .catch(err => {
          console.log("Erro ao fazer upload: ", err);

         if(err?.data?.cod_erro == 10000){
            let msg = "Há mais de um arquivo dentro do ZIP.<br>Adicione apenas um arquivo CSV.";
            this.$toast.error(msg,"", { position: "topRight", timeout: 8000 });
          }else{
            this.$toast.error("Erro no upload do arquivo.", "", { position: "topRight" });
          }

          this.arquivo.fileObj = undefined;
        })
        .finally(() => this.arquivo.uploading = false)
    },

    getMesImportacao() {
      IndicesCOGE.getMesImportacao()
        .then((response) => {
          this.mesImportacao = this.formatMonth(response.data.dado);
        })
        .catch((err) => {
          this.$toast.error("Erro ao recuperar mês de importação", "", {
            position: "topRight",
          });
          console.error(err);
        })
        .finally(() => this.iniciarTourPagina());
    },

    openDialogPreview(arquivoId) {
      IndicesCOGE.importar(arquivoId)
        .then((response) => {
          this.indicesPreview = response.data.dados;
          this.dialogPreview = true;
        })
        .catch((erro) => {

          console.log("Erro ao tentar ler  o arquivo ", erro);
          this.$toast.error("O arquivo selecionado não parece ser válido para essa importação.", "", {
            position: "topRight",
          });
          this.arquivo.fileObj = undefined;
        });
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      this.iniciarTour(this.arrTour);
    }

  },
};
</script>